import { employeeSchema } from "@/components/Forms/schema/employeeSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceSelector } from "jsonapi-zod-query";

const employeeSelector = createResourceSelector({
    type: "employee",
    attributesSchema: employeeSchema,
});

export type Employee = ReturnType<typeof employeeSelector>;

export const useFetchCurrentEmployee = (): UseQueryResult<Employee> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["current-employee"],
        queryFn: async ({ signal }) => {
            const url = apiUrl("/employee");

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/vnd.api+json",
                },
            });

            return await response.json();
        },
        select: employeeSelector,
    });
};
